var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"timeframe-selector"}},[(_vm.events.length > 0)?_c('div',{attrs:{"id":"timeline"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }